import * as React from 'react';
import { CompactGrid, CompactContent } from '../../components/UI/CompactUI';
import TopBar from '../Site/TopBar';
import { withThemer, ThemerProps } from '../../helpers/withThemer';
import { ThemeProvider } from 'styled-components';
import CompactFooter from '../Site/CompactFooter';

interface DashProps {
  children: React.ReactNode;
}

type Props = ThemerProps & DashProps;

const CompactLayout: React.SFC<Props> = ({ children, theme, updateTheme }) => (
  <ThemeProvider theme={{ mode: theme }}>
    <CompactGrid>
      <TopBar />
      <CompactContent>{children}</CompactContent>
      <CompactFooter />
    </CompactGrid>
  </ThemeProvider>
);

export default withThemer(CompactLayout);



// WEBPACK FOOTER //
// ./src/containers/Layouts/CompactLayout.tsx